export default __webpack_public_path__ + "static/media/lake.a5379e94.webp";